// DS1.13
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Url } from '@wix/da-url';
import s from './Loader.scss';
const Loader = ({ size , state ='loading' , className  })=>{
    const pride = useFlag('pride23');
    const getImagePath = (state)=>({
            loading: pride ? 'loading/llama-pride22.gif' : 'loading/llama-med.gif',
            static: 'loading/llama-static.gif',
            disabled: 'loading/llama-disabled.png',
            popcorn: 'loading/llama-popcorn.gif',
            eating: 'loading/llama-eating.gif',
            eating_grass: 'loading/llama-eating-grass.gif?1',
            spitting: 'loading/llama-spitting.gif'
        })[state];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], s[state], className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: Url.staticCDNLink(getImagePath(state)),
        alt: "",
        className: s['llama']
    }));
};
Loader.displayName = 'Loader';
export default Loader;
